/**
 * RESPONSIBILITY: the church's mission and its vision, side by side.
 *
 * One band because they are one statement in two halves — what the church is for, and
 * what it is aiming at. Splitting them into two bands would put a pencil between two
 * sentences that are written together and changed together.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, RenderOf } from '@framework/core/decorators';
import { SectionName } from '../section-names';

@Section({ name: SectionName.AboutPurpose, label: 'About · Mission and vision' })
export class AboutPurposeSection {
  @Text({ label: 'Title', maxLength: 300, default: 'Our mission', group: 'Mission' })
  missionHeading!: string;

  @Paragraph({
    label: 'Mission', maxLength: 20000, rows: 5, markdown: true, allow: ['verse'],
    group: 'Mission',
  })
  mission!: string;

  @RenderOf('mission')
  missionHtml!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'Our vision', group: 'Vision' })
  visionHeading!: string;

  @Paragraph({
    label: 'Vision', maxLength: 20000, rows: 5, markdown: true, allow: ['verse'],
    group: 'Vision',
  })
  vision!: string;

  @RenderOf('vision')
  visionHtml!: string;
}
